// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"0bf6c89e","775":"f2905a3e","967":"e7222d74"}[chunkId] + ".chunk.css";
};